import i18n from '../i18n';

// Preserve actionable API errors (especially ERP scheduling rejections) instead
// of replacing them with a generic "request failed" toast in each UI surface.
//
// El backend puede devolver una CLAVE i18n en `message`/`error` (p. ej.
// `experimentStartsTooSoon`) junto con sus `messageParams`. Se traduce aquí, en un único
// sitio, para que cualquier pantalla que ya use este helper enseñe el motivo real en el
// idioma del usuario; una frase que no sea clave se devuelve tal cual.
export const getApiErrorMessage = (error, fallback = 'Request failed') => {
  const payload = error?.response?.data;
  const translate = (value) => (
    typeof value === 'string' && value
      ? i18n.t(value, { defaultValue: value, ...(payload?.messageParams || {}) })
      : value
  );

  if (payload?.code === 'ERP_SCHEDULING_FAILED') {
    return translate(payload.message || payload.error)
      || 'Your ERP could not schedule this experiment. Nothing was saved.';
  }
  return translate(payload?.message || payload?.error) || error?.message || fallback;
};
